import React from 'react';
import PropTypes from 'prop-types';
import Amplify from 'aws-amplify';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import {
  MuiThemeProvider,
  createMuiTheme,
  responsiveFontSizes,
} from '@material-ui/core/styles';

import cognitoConfig from './aws-exports';
import Root from 'Containers/root/index';
import Notifier from 'Components/content/notifier';

Amplify.configure(cognitoConfig);

const browserSupportsHistoryApi = 'pushState' in window.history;

let appTheme = createMuiTheme({
  spacing: 8,
  palette: {
    type: 'light',
    primary: {
      main: '#F37E3A',
      light: '#FCBA55',
    },
    secondary: {
      main: '#E5E8EE',
    },
    background: {
      page: '#F7F7F7',
      navigation: '#000000',
    },
    text: {
      primary: '#000000',
      navigation: '#FFFFFF',
    },
    selection: {
      navigation: '#FC9D2B',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['"Montserrat"', 'sans-serif'].join(','),
    body2: {
      fontSize: '13px',
    },
    body1: {
      fontSize: '15px',
    },
  },
});

appTheme = responsiveFontSizes(appTheme);

const App = ({ store }) => (
  <Provider store={store}>
    <BrowserRouter forceRefresh={!browserSupportsHistoryApi}>
      <MuiThemeProvider theme={appTheme}>
        <CssBaseline />
        <Root />
        <Notifier />
      </MuiThemeProvider>
    </BrowserRouter>
  </Provider>
);

App.propTypes = {
  store: PropTypes.object.isRequired,
};

const detectCountry = () => {
  localStorage.setItem('country', 'in');
  fetch('https://ipinfo.io?token=1863fc63235081')
    .then(response => response.json())
    .then(ipInfo => {
      localStorage.setItem('country', ipInfo.country.toLowerCase());
    })
    .catch(error => {
      //this.setState({ error });
    });
};

detectCountry();
export default App;
